var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2744 9.0509C10.9663 8.10889 11.375 6.94592 11.375 5.6875C11.375 2.54638 8.82862 0 5.6875 0C2.54638 0 0 2.54638 0 5.6875C0 8.82862 2.54638 11.375 5.6875 11.375C6.94626 11.375 8.10951 10.9661 9.05166 10.2738L9.0509 10.2744C9.07671 10.3094 9.10545 10.3429 9.13713 10.3746L12.5063 13.7437C12.848 14.0854 13.402 14.0854 13.7437 13.7437C14.0854 13.402 14.0854 12.848 13.7437 12.5063L10.3746 9.13713C10.3429 9.10545 10.3094 9.07671 10.2744 9.0509ZM10.5 5.6875C10.5 8.34537 8.34537 10.5 5.6875 10.5C3.02963 10.5 0.875 8.34537 0.875 5.6875C0.875 3.02963 3.02963 0.875 5.6875 0.875C8.34537 0.875 10.5 3.02963 10.5 5.6875Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.dbf46959fadcba4a4d1593ae77752387.svg";
export { ForwardRef as ReactComponent };